if (window.location.host.toLowerCase().includes('uk')){
    window.site = 'UK'
  }
  else if (window.location.host.toLowerCase().includes('eu')){
    window.site = 'EU'
  }
  else if (window.location.host.toLowerCase().includes('ca')){
    window.site = 'CA'
  }
  else {
    window.site = 'US'
  }
  